<template>
  <div class="mortgage-deeds-table">
    <AppCard v-if="newMortgageDeedsCost" class="new-mortgage-deeds-cost-card">
      <div>
        Nya pantbrev för <b>{{ formatAmount(newMortgageDeedsCost.totalDeedAmount) }}</b> kr kommer att tas ut.
        <br />
        Det kommer att kosta kunden
        <b>{{ formatAmount(newMortgageDeedsCost.totalCost) }}</b> kr ({{
          formatPercentage((newMortgageDeedsCost.stampDutyRate ?? 0) * 100)
        }}
        stämpelskatt + {{ formatAmount(newMortgageDeedsCost.administrativeFee) }} kr expeditionsavgift).
      </div>
    </AppCard>

    <AppTable>
      <thead>
        <tr>
          <th>#</th>
          <th>Inskrivning</th>
          <th>Aktnr</th>
          <th>Belopp</th>
          <th>Fastighetsbeteckning</th>
          <th />
          <th>Mottaget</th>
        </tr>
      </thead>
      <tbody>
        <AppTableRow v-for="(deed, i) in mortgageDeeds" :key="i">
          <AppTableCell>{{ deed.index ?? i + 1 }}</AppTableCell>
          <AppTableCell>{{ formatDateIfValid(deed.createdAt) ?? '-' }}</AppTableCell>
          <AppTableCell>{{ deed.number || '-' }}</AppTableCell>
          <AppTableCell>{{ formatAmount(deed.amount) }} kr</AppTableCell>
          <AppTableCell>{{ deed.propertyLabel || '-' }}</AppTableCell>
          <AppTableCell>
            <span v-if="deed.isPaper" class="paper-deed-icon" title="Skriftligt pantbrev">
              <SvgIcon :path="mdiPen" :size="18" />
            </span>
          </AppTableCell>
          <AppTableCell>{{ formatDateIfValid(deed.receivedDate) ?? '-' }}</AppTableCell>
        </AppTableRow>
      </tbody>
    </AppTable>
  </div>
</template>

<script setup lang="ts">
import { formatAmount, formatDateIfValid, formatPercentage } from '@staff/shared'
import { mdiPen } from '@mdi/js'

import AppTable from '../AppTable/AppTable.vue'
import AppTableRow from '../AppTable/AppTableRow.vue'
import AppTableCell from '../AppTable/AppTableCell.vue'
import AppCard from '../AppCard/AppCard.vue'
import SvgIcon from '../SvgIcon/SvgIcon.vue'

export interface MortgageDeed {
  amount: number
  exists?: boolean
  isPaper?: boolean
  index?: number | null
  number?: string | null
  createdAt?: string | null
  propertyLabel?: string | null
  receivedDate?: string | null
}

export interface NewMortgageDeedsCost {
  totalDeedAmount: number
  totalCost: number
  stampDutyRate: number
  administrativeFee: number
}

defineProps<{
  mortgageDeeds?: MortgageDeed[] | null
  newMortgageDeedsCost?: NewMortgageDeedsCost | null
}>()
</script>

<style lang="scss" scoped>
.mortgage-deeds-table {
  padding: 0 8px 8px;

  .new-mortgage-deeds-cost-card.card {
    margin-bottom: 24px;
    background-color: var(--color-warning-subtle);
    border: 1px solid var(--color-warning-emphasis);
    color: var(--color-warning-on-subtle);
  }
}
.paper-deed-icon {
  color: var(--color-danger-fg, #d1242f);
}
</style>
